import React, { useState } from "react";
import QuoteModal from "./QuoteModal";
import { useNavContext } from "../../context-api/nav-context";
import { loadStripe } from "@stripe/stripe-js";

const Results = ({ index, name, img, desc, size, id, price }) => {
  const { setIsCallOpen } = useNavContext();
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);
  let stripePromise;

  const getStripe = () => {
    if (!stripePromise) {
      stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
    }
    return stripePromise;
  };

  let priceID;
  if (id === "61f14ff32b1460726c89bf36") {
    priceID = "price_1KQte1JgCXJNxxAzMDcCF7AI";
  }
  if (id === "61f14ff32b1460726c89bf37") {
    priceID = "price_1KQtd8JgCXJNxxAzA7X1vQhy";
  }
  if (id === "61f14ff32b1460726c89bf30") {
    priceID = "price_1KQtbpJgCXJNxxAznOGdw13X";
  }
  if (id === "61f14ff32b1460726c89bf24") {
    priceID = "price_1KQta8JgCXJNxxAzdQvwMNlL";
  }
  if (id === "61f14ff32b1460726c89bf34") {
    priceID = "price_1KQtYWJgCXJNxxAzgHg36VfC";
  }
  if (id === "61f14ff32b1460726c89bf32") {
    priceID = "price_1KQtUsJgCXJNxxAz661doevZ";
  }
  if (id === "61f14ff32b1460726c89bf31") {
    priceID = "price_1KQtThJgCXJNxxAzOljYPmGl";
  }
  if (id === "61f14ff32b1460726c89bf2b") {
    priceID = "price_1KQtSYJgCXJNxxAzH7Rb00Bt";
  }
  if (id === "61f14ff32b1460726c89bf2d") {
    priceID = "price_1KQtRVJgCXJNxxAzOtLfzSQc";
  }
  if (id === "61f14ff32b1460726c89bf2e") {
    priceID = "price_1KQtQDJgCXJNxxAzUkrWHCqv";
  }
  if (id === "61f14ff32b1460726c89bf2f") {
    priceID = "price_1KQtOzJgCXJNxxAz4DsLgiEq";
  }
  if (id === "61f14ff32b1460726c89bf2c") {
    priceID = "price_1KQtNuJgCXJNxxAzfBX2vMf0";
  }
  if (id === "61f14ff32b1460726c89bf27") {
    priceID = "price_1KQtM9JgCXJNxxAzfYQTgDYr";
  }
  if (id === "61f14ff32b1460726c89bf2a") {
    priceID = "price_1KQtLAJgCXJNxxAzgIsIXia8";
  }
  if (id === "61f14ff32b1460726c89bf29") {
    priceID = "price_1KQtKKJgCXJNxxAz01Mvy3SD";
  }
  if (id === "61f14ff32b1460726c89bf28") {
    priceID = "price_1KQtJOJgCXJNxxAzjdb1wkJK";
  }
  if (id === "61f14ff32b1460726c89bf24") {
    priceID = "price_1KQtIBJgCXJNxxAzJ891rPc7";
  }
  if (id === "61f14ff32b1460726c89bf25") {
    priceID = "price_1KQtEzJgCXJNxxAzq7UlSUXi";
  }
  if (id === "61f14ff32b1460726c89bf26") {
    priceID = "price_1KQqrDJgCXJNxxAzNlIeiVqK";
  }

  const item = {
    price: priceID,
    quantity: 1,
  };

  const checkoutOptions = {
    lineItems: [item],
    mode: "payment",
    successUrl: `${window.location.origin}/success`,
    cancelUrl: `${window.location.origin}/cancel`,
  };

  const redirectToCheckOut = async () => {
    console.log("redirect to checkout");
    try {
      const stripe = await getStripe();
      await stripe.redirectToCheckOut(checkoutOptions);
    } catch (err) {
      console.log("Stripe checkout error", err);
    }
  };

  const openQuoteForm = () => {
    setIsQuoteOpen(true);
  };

  const openCallUs = () => {
    setIsCallOpen(true);
  };
  return (
    <>
      <div className="price-card">
        <div className="price-card-img">
          <div className="price-card-img-wrapper">
            <img src={img} alt="" />
          </div>
        </div>
        <div className="price-card-info">
          <h3 className="price-card-title">{name}</h3>
          <h4 className="price-card-sub">Powers up to 10 radiators.</h4>
          <p className="price-p">{desc}</p>
          <div className="price-card-info-ratings">
            <div className="popular pop">Popular</div>
            <div className="popular finance">Finance Available</div>
          </div>
          <div className="price-card-info-specs">
            <div className="spec-row">
              <div className="spec-row-title">
                <h4>Hot Water Flow Rate</h4>
              </div>
              <div className="spec-row-num">
                <span>7</span>
              </div>
            </div>
            <div className="spec-row">
              <div className="spec-row-title">
                <h4>Central Heating Output</h4>
              </div>
              <div className="spec-row-num">
                <span>{size}</span>
              </div>
            </div>
            <div className="spec-row">
              <div className="spec-row-title">
                <h4>Warrenty</h4>
              </div>
              <div className="spec-row-num">
                <span>10</span>
              </div>
            </div>
          </div>
        </div>
        <div className="price-card-quote">
          <div className="price-card-quote-header">
            <h3 className="price-quote-title">Your fixed installation price</h3>
          </div>
          <div className="price-card-quote-body">
            <h1 className="price">£{price}</h1>
            <p className="quote-small-sub">Including VAT</p>
            <p className="quote-small-sub">or from £26 per month (10.9% APR)</p>
          </div>
          <div className="price-card-quote-footer">
            <button className="btn-price btn-back" onClick={openCallUs}>
              Call Us Now
            </button>
            <button className="btn-price" onClick={redirectToCheckOut}>
              Choose
            </button>
            <button className="btn-price btn-back" onClick={openQuoteForm}>
              Save This Quote
            </button>
          </div>
        </div>
        <div className={isQuoteOpen ? "quote-form" : "hide"}>
          <QuoteModal id={id} setIsQuoteOpen={setIsQuoteOpen} />
        </div>
      </div>
    </>
  );
};

export default Results;
